import noop from 'lodash/noop';
import { createActions } from 'redux-actions';
export const holdMusicActions = createActions({
    HOLD_MUSIC_GET_ALL: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    HOLD_MUSIC_UPLOAD: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    HOLD_MUSIC_SPLIT: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
}, 'HOLD_MUSIC_GET_ALL_SUCCEEDED', 'HOLD_MUSIC_GET_ALL_FAILED', 'HOLD_MUSIC_UPLOAD_SUCCEEDED', 'HOLD_MUSIC_UPLOAD_FAILED', 'HOLD_MUSIC_SPLIT_SUCCEEDED', 'HOLD_MUSIC_SPLIT_FAILED', 'HOLD_MUSIC_SELECT', 'HOLD_MUSIC_RESET', 'HOLD_MUSIC_SHOW_MODAL', 'HOLD_MUSIC_HIDE_MODAL', 'HOLD_MUSIC_WS_UPLOAD_STATUS', 'HOLD_MUSIC_HOLDING_FOR_SPLITING_OPEN', 'HOLD_MUSIC_HOLDING_FOR_SPLITING_CLOSE');
